"use client";

import { useActionState, useState } from "react";
import { useSearchParams } from "next/navigation";
import { loginAction } from "./actions";
import { Sword, Eye, EyeOff } from "lucide-react";

export default function LoginPage() {
  const [state, formAction, pending] = useActionState(loginAction, null);
  const [showPw, setShowPw] = useState(false);
  const params = useSearchParams();
  const passwordReset = params.get("reset") === "1";

  const inputCls =
    "w-full bg-stone-800 border border-amber-900/40 rounded-lg px-4 py-3 text-amber-100 placeholder-amber-200/25 focus:outline-none focus:border-amber-600/60 transition-colors";

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Header */}
        <div className="flex flex-col items-center mb-8 gap-3">
          <Sword className="text-amber-500" size={40} />
          <h1 className="font-[family-name:var(--font-cinzel)] text-2xl font-bold text-amber-400 tracking-wide text-center">
            TTRPG Character Vault
          </h1>
          <p className="text-amber-200/40 text-sm">Sign in to access your characters</p>
        </div>

        {/* Card */}
        <div className="rounded-xl border border-amber-900/40 bg-stone-900 p-6 space-y-5">
          {passwordReset && (
            <div className="rounded-lg bg-green-900/30 border border-green-800/50 text-green-400 text-sm px-4 py-3">
              Password updated. Please sign in with your new password.
            </div>
          )}

          {state?.error && (
            <div className="rounded-lg bg-red-900/30 border border-red-800/50 text-red-400 text-sm px-4 py-3">
              {state.error}
            </div>
          )}

          <form action={formAction} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-amber-500/60 mb-1.5 block">
                Email
              </label>
              <input
                type="email"
                name="email"
                className={inputCls}
                placeholder="you@example.com"
                required
                autoFocus
              />
            </div>

            <div>
              <label className="text-xs uppercase tracking-widest text-amber-500/60 mb-1.5 block">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPw ? "text" : "password"}
                  name="password"
                  className={inputCls + " pr-10"}
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPw(v => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-amber-200/30 hover:text-amber-200/60 transition-colors"
                >
                  {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={pending}
              className="w-full py-3 rounded-lg bg-amber-700 hover:bg-amber-600 text-white font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-2"
            >
              {pending ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>

        <p className="text-center text-amber-200/20 text-xs mt-6">
          Contact your admin to create an account.
        </p>
      </div>
    </div>
  );
}
